import { Modal, ModalBody, ModalHeader } from "reactstrap";
import AttendanceList from "../../commons/Attendance/AttendanceList";

type AppProps = {
  toggleModal: () => void;
  isOpen: boolean;
  attendenceData: any;
  totalAttendanceHours: number;
  fetching: boolean;
  date: string;
  location: string;
  name?:string;
  type?:string

};

const SingleAttendanceModal = ({
  toggleModal,
  isOpen,
  attendenceData,
  totalAttendanceHours,
  fetching,
  date,
  location,
  name,
  type
}: AppProps) => {
  const stylingType = "attendenceReport"
  return (
    <Modal isOpen={isOpen} toggle={toggleModal} size='xl' >
      <ModalHeader className="pt-2 pl-4" id="cross-cut" toggle={toggleModal}>
        Attendance Report
      </ModalHeader>
      <ModalBody className="pl-3 pr-4">
        <div className="thinScroll">
          <div
              className="d-flex"
              style={{ padding: "0px 31px", textAlign: "center",flexDirection:"column",justifyContent:"center",gap:"5px" }}
            >
                <div style={{ color: "#7C8DB0", fontSize: "12px" }}>
                  {location?location:""}
                </div>

                <div style={{ color: "#6e7491" }}>
              Report for {date}
            </div>
            {type=="allUser" ? 
            <div style={{ color: "#000000" , fontWeight:'500'}}>
              Name - {name}
            </div>
            :""}
          </div>

          <AttendanceList
            attendenceData={attendenceData}
            totalAttendanceHours={totalAttendanceHours}
            fetching={fetching}
            stylingType={stylingType}
          />
        </div>
      </ModalBody>
    </Modal>
  );
};

export default SingleAttendanceModal;
